import React from 'react';

const CohortPreview = ({ cohort, filters, brandFacets, facetsLoading, onToggleFacetBrand, onPreview, onOpenShopperList }) => {
  const { excludeRecentDays, setExcludeRecentDays, brandIds } = filters;
  const exclusionDays = parseInt(excludeRecentDays, 10) > 0 ? parseInt(excludeRecentDays, 10) : null;
  // The window the backend counted over: the custom exclusion when set, the 14-day default otherwise.
  const windowDays = cohort.recentWindowDays || 14;
  return (
  <div className='nb-card nb-cohort-card'>
    <div className='nb-cohort-top'>
      <div className='nb-cohort-left'>
        <div className='nb-cohort-count-row'>
          <span className='nb-cohort-count'>{cohort.withPhone}</span>
          <span className='nb-cohort-count-label'>shoppers matched</span>
        </div>
        <p className='nb-cohort-meta'>
          {cohort.withPhone} with connected phone · {Math.max(cohort.total - cohort.withPhone, 0)} excluded (no phone or SMS consent)
          {cohort.truncated && ` · showing top ${cohort.matched.length} by score (broadcast hits all ${cohort.withPhone})`}
        </p>

        {cohort.recentlyMessagedCount > 0 && !exclusionDays && (
          <div className='nb-warn-callout'>
            <div className='nb-warn-row'>
              <span className='nb-warn-icon'>⚠</span>
              <div>
                <p className='nb-warn-title'>
                  {cohort.recentlyMessagedCount} shopper{cohort.recentlyMessagedCount !== 1 ? 's' : ''} received a message within the last{' '}
                  {windowDays} days
                </p>
                <p className='nb-warn-sub'>They'll still receive this message unless excluded.</p>
                <button
                  className='nb-warn-action'
                  onClick={() => {
                    setExcludeRecentDays(String(windowDays));
                    onPreview({ excludeRecentDays: windowDays });
                  }}
                >
                  Exclude these {cohort.recentlyMessagedCount} shoppers →
                </button>
              </div>
            </div>
          </div>
        )}

        {exclusionDays > 0 && cohort.recentlyMessagedCount > 0 && (
          <div className='nb-excluded-pill'>
            <span className='nb-excluded-text'>
              ✓ {cohort.recentlyMessagedCount} shoppers messaged within {windowDays} days excluded
            </span>
            <button
              className='nb-excluded-undo'
              onClick={() => {
                setExcludeRecentDays('');
                onPreview({ excludeRecentDays: null });
              }}
            >
              undo
            </button>
          </div>
        )}

        {cohort.withPhone === 0 && <p className='nb-zero-warning'>No shoppers match. Try broadening your filters.</p>}

        {facetsLoading && <p className='nb-facet-loading'>Finding common brands…</p>}
        {brandFacets?.brands?.length > 0 && (
          <div className='nb-brand-facets'>
            <p className='nb-facet-title'>
              Common brands amongst these shoppers — click to narrow
              {brandFacets.sampled && ` (top ${brandFacets.sampleSize.toLocaleString()} sampled)`}
            </p>
            <div className='nb-facet-chips'>
              {brandFacets.brands.map(b => {
                const active = brandIds.includes(b.id);
                return (
                  <button key={b.id} className={active ? 'nb-facet-chip active' : 'nb-facet-chip'} onClick={() => onToggleFacetBrand(b.id)}>
                    {b.name} <span className='nb-facet-count'>{b.shopperCount}</span>
                    {active && <span className='nb-facet-x'>×</span>}
                  </button>
                );
              })}
            </div>
          </div>
        )}
      </div>
      <button className='nb-view-list-btn' onClick={onOpenShopperList}>
        View shopper list →
      </button>
    </div>
    </div>
  );
};

export default CohortPreview;
